export default __webpack_public_path__ + "static/media/dashboard.4147a932.svg";